
import React, { useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import GigCard from './GigCard';
import { mockGigs } from './mockGigData';
import { Badge } from '@/components/ui/badge';

const UpcomingGigs: React.FC = () => {
  const [filter, setFilter] = useState<'all' | 'confirmed' | 'pending'>('all');
  const [sourceFilter, setSourceFilter] = useState<'all' | 'local' | 'songkick' | 'eventbrite'>('all');
  
  const filteredGigs = mockGigs.filter(gig => {
    // Status filter
    const statusMatch = filter === 'all' || gig.status === filter;
    
    // Source filter
    const sourceMatch = 
      sourceFilter === 'all' || 
      (sourceFilter === 'local' && (!gig.source || gig.source === 'local')) ||
      (gig.source === sourceFilter);
    
    return statusMatch && sourceMatch;
  });

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center flex-wrap gap-3">
        <h2 className="text-xl font-semibold">Upcoming Performances</h2>
        <div className="flex gap-3 flex-wrap">
          <Tabs value={filter} onValueChange={(value) => setFilter(value as any)} className="w-auto">
            <TabsList className="grid grid-cols-3">
              <TabsTrigger value="all">All</TabsTrigger>
              <TabsTrigger value="confirmed">Confirmed</TabsTrigger>
              <TabsTrigger value="pending">Pending</TabsTrigger>
            </TabsList>
          </Tabs>
          
          <div className="flex items-center gap-1">
            <span className="text-sm text-muted-foreground mr-1">Source:</span>
            <Badge 
              variant={sourceFilter === 'all' ? 'default' : 'outline'} 
              className="cursor-pointer"
              onClick={() => setSourceFilter('all')}
            >
              All
            </Badge>
            <Badge 
              variant={sourceFilter === 'local' ? 'default' : 'outline'} 
              className="cursor-pointer"
              onClick={() => setSourceFilter('local')}
            >
              Local
            </Badge>
            <Badge 
              variant={sourceFilter === 'songkick' ? 'neon-purple' : 'outline'} 
              className="cursor-pointer"
              onClick={() => setSourceFilter('songkick')}
            >
              Songkick
            </Badge>
            <Badge 
              variant={sourceFilter === 'eventbrite' ? 'neon-pink' : 'outline'} 
              className="cursor-pointer"
              onClick={() => setSourceFilter('eventbrite')}
            >
              Eventbrite
            </Badge>
          </div>
        </div>
      </div>

      <Card>
        <CardContent className="p-0">
          <ScrollArea className="h-[600px]">
            <div className="divide-y divide-border">
              {filteredGigs.length > 0 ? (
                filteredGigs.map(gig => (
                  <GigCard key={gig.id} gig={gig} />
                ))
              ) : (
                <div className="p-6 text-center text-muted-foreground">
                  No gigs found matching your filters.
                </div>
              )}
            </div>
          </ScrollArea>
        </CardContent>
      </Card>
    </div>
  );
};

export default UpcomingGigs;
